var initialState = {
  meta: {
    loading: false,
    error: false,
    activeSltId: null,
    initialLoadPending: true
  },
  ids: []
};
export default initialState;